import locale from "localization/en";

export const cashOnHandColumn = [
  { key: "denomination", text: locale.denomination },
  { key: "safeDrops", text: locale.safeDrops },
  { key: "endShift", text: locale.endOfShift },
  { key: "total", text: locale.total },
  { key: "totalAmount", text: locale.totalAmount },
];
